import { Site } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import {
  NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
  mustNotContainNumber,
  mustNotContainSymbols,
  noWhiteStartOrEnd,
  required
} from '@swf/core/utils/validators';

import useAutoFocusInput from '../../../../../../hooks/useAutoFocusIf';
import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTWCL_First_name,
  TXTWCL_Please_enter_your_first_nameX,
  TXTWCL_Please_enter_your_first_name_a_ELL,
  TXTWCL_The_name_you_have_entered_is_i_ELL
} from './GivenName.messages.json';

const fieldName = 'firstName';
const maxLength = 50;

interface Props {
  autoFocus: boolean;
}

const GivenName: React.FC<Props> = ({ autoFocus }) => {
  const inputRef = useAutoFocusInput(autoFocus);
  const isRO = useSelector(select.cms.getSiteId) === Site.RO;

  return (
    <TextInput
      id={fieldName}
      label={TXTWCL_First_name}
      maxLength={maxLength}
      checkDisabled
      helperMessage={isRO && <Translation {...TXTWCL_Please_enter_your_first_name_a_ELL} />}
      validators={[
        noWhiteStartOrEnd,
        required(TXTWCL_Please_enter_your_first_nameX),
        mustNotContainNumber(TXTWCL_The_name_you_have_entered_is_i_ELL),
        mustNotContainSymbols(
          NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
          TXTWCL_The_name_you_have_entered_is_i_ELL
        )
      ]}
      inputRef={inputRef}
    />
  );
};

export default GivenName;
